import React from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import stylisPluginRtl from 'stylis-plugin-rtl';

const rtlCache = createCache({ key: 'muirtl', stylisPlugins: [stylisPluginRtl] });
const ltrCache = createCache({ key: 'mui' });

const RtlProvider: React.FC<{ isRTL: boolean; children: React.ReactNode }> = ({ isRTL, children }) => (
  <CacheProvider value={isRTL ? rtlCache : ltrCache}>
    {children}
  </CacheProvider>
);

export default RtlProvider;
